export default "__VITE_ASSET__nw_2HtS0__";